import React, { useEffect, useState } from 'react';
import api from '~/services/api';

import { Container } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import IconCheck from '~/assets/icones/IconCheck.svg';
import ShowConfirmacao from '~/utils/ShowConfirmacao';


function CreateEditContent({ mountedData }) {
  const [despesas, setDespesas] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [cliente, setCliente] = useState(
    mountedData ? mountedData?.cliente : {},
  );
  const [ativo, setAtivo] = useState(
    !mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false',
  );

  useEffect(() => {
    api
      .get('/signed/empresa/gestorprojeto/gerencia/recursos', {
        params: { ativo: 1 },
      })
      .then(response => {
        let lista = [];
        response.data.map(e => {
          lista.push({
            id: e?.id,
            titulo: e?.titulo,
          });
        });
        setDespesas(lista);
      });

    let listaHora = [];
    listaHora.push({
      id: 1,
      titulo: 'º Horário',
      horaIni: '00:00',
      horaFim: '08:00',
    });
    listaHora.push({
      id: 2,
      titulo: 'º Horário',
      horaIni: '09:00',
      horaFim: '12:00',
    });
    listaHora.push({
      id: 3,
      titulo: 'º Horário',
      horaIni: '13:00',
      horaFim: '23:00',
    });
    setHorarios(listaHora);
    
  }, []);  

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
        };
        let response;
        if (mountedData?.id)
          response = await api.put(
            '/signed/empresa/gestorprojeto/aprovaros/aprovaros',
            thisData,
          );
        else
          response = await api.post(
            '/signed/empresa/gestorprojeto/aprovaros/aprovaros',
            thisData,
          );

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } esse Produto, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } esse Produto?`,
        successModal: `Produto ${
          mountedData?.id ? 'atualizado' : 'cadastrado'
        } com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são
            campos obrigatórios
          </p>
        </div>
        <div className="row">
          <div className="col s8 m8 l8">
            <div className="row">
              <div className="content-full">
                <div className="content-first">
                  <div className="text">
                    <p className="cod">#00001</p>
                    <p className="bold">Nome do Projeto</p>
                    <p className="title">LOCOMOTIVA</p>
                  </div>
                  <div className="info">
                    <p className="bold">Data de Abertura</p>
                    <p className="title">05/05/2023</p>
                  </div>
                </div>
                <div className="content-second">
                  <div className="text">
                    <p className="bold">Título</p>
                    <p className="title">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur.
                    </p>
                  </div>
                </div>
                <div className="content-third">
                  <div className="text">
                    <p className="bold">Despesas</p>
                    <p className="title"></p>
                  </div>
                </div>
                {despesas &&
                  despesas?.map(item => (
                    <div className="acordion">
                      <div className="despesa">
                        <img src={IconCheck} alt="check" />
                        <p className="title">{item?.titulo}</p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="col s4 m4 l4">
            <div className="content-hour">
              <div className="text">
                <p className="bold">Desconto</p>
                <p className="title">01:00</p>
              </div>
              <div className="text">
                <p className="bold">Translado</p>
                <p className="title">01:00</p>
              </div>
              <div className="card-content">
                <div className="card-cod">
                  <p className="cod">Total</p>
                </div>
                <p className="title">10h</p>
              </div>
            </div>
            <div className="row-left">
              <div className="col s12 m12 l12">
                {horarios &&
                  horarios?.map(item => (
                    <div className="card">
                      <div className="card-content">
                        <div className="card-cod">
                          <p className="cod">
                            {item?.id} {item?.titulo}
                          </p>
                        </div>
                      </div>
                      <div className="content-body">
                        <div className="start">
                          <p className="bold">Hora Inicial</p>
                          <p className="title">{item?.horaIni}</p>
                        </div>
                        <div className="end">
                          <p className="bold">Hora Final</p>
                          <p className="title">{item?.horaFim}</p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
